module.exports = __webpack_public_path__ + "static/media/defaultBlog.3e9d9ca2.png";